import React, {useContext, useState, useEffect} from 'react'
import "../Judumas.css"
import { MapContext } from '../MapContext';
import { queryFeaturesOverLimit2k } from '../helpers/helper';
import { utils, writeFile } from 'xlsx';
import * as featureService from "../Services/serviceLayers";

// exportavimo elementas, naudojamas compareSidebar'e
export default function ExcelExport() {
  const mapContext = useContext(MapContext);  
  // paspaudus atsisiusti, suformatuojama pagal parinkta uzduoti irasoma i sate kai pasikeicia sate parsiunciamas failas
  const [excelData, setExcelData] = useState(null);

  // suikuriamas queris duomenims gauti, paduodami osm id ir compareDate - jei tai laiko palyginimas ir querinama antras datos rezis, osmLineQuer, jei querinama be datos
  function createQuery(idArray, compareDate = 0, osmLineQuer = 0 ) {
    let queryWhere
    if (osmLineQuer === 1) {
        queryWhere = "osm_id IN ("
    } else {
        queryWhere = "osm_id IN ("
    }
    idArray.forEach(element => {

      //console.log(element, typeof element)
      if (element !== undefined && element !== null){
        queryWhere += element + ","
      }   
    })
    queryWhere = queryWhere.slice(0,-1)
    if (osmLineQuer === 1 ) {
        queryWhere += ")"
    }
    else if (compareDate === 0) {
      queryWhere += ") and " + mapContext.state.dateRange;
    } else {
      queryWhere += ") and " + mapContext.state.compareDate;
    }
   

    var query = mapContext.state.dataFeatureLayer.createQuery();
    query.where = queryWhere;

    return query 
  }

  // apjungiami arrays  osm tinklo duomenu ir operatoriu duomenu layerio pagal osm_id (nes gatves pavadinimas nesaugomas operatoriu layerije)
  function mergeArr(dataArr, osmArr) {
    dataArr.forEach(element => {
        osmArr.forEach(osmElement => {
            if (element.osm_id === osmElement.osm_id) {
                Object.assign(element, osmElement);
            }
        })
    });
  }

  // Nurodomas transporto tipas pagal layerio id, teritorijoje lyginami skirtingi transporto tipai todel vietoj 1 nurodymo pavadinime ar kur kitur nurodoma individualioje eiluteje.
  function addTransportType (layer, element) {
    if (layer === 32) {
        element.transport_type = "Automobilis"
        return element
    } else if (layer === 31) {
        element.transport_type = "Dviratis"
        return element
    } else if (layer === 34) {
        element.transport_type = "Viešasis transportas"
        return element
    } else if (layer === 33) {
        element.transport_type = "Pestieji"
        return element
    }
}
  
// paquerinami osm tinklo layeris ir operatoriu tinklai teritorijos palyginime, ir sudedami i viena array'u exportavimui
async  function formatDataTer() {
    let l1Query
    let l2Query
    let l1osmQuery
    let l2osmQuery
    //console.log(mapContext.state.selectedStreetArray[0])
    if (mapContext.state.selectedStreetArray.length > 1) {
      l1Query = createQuery(mapContext.state.selectedStreetArray[1])
      l2Query = createQuery(mapContext.state.selectedStreetArray[1])
      l1osmQuery = createQuery(mapContext.state.selectedStreetArray[1], 0, 1)
      l2osmQuery = l1osmQuery
      //console.log(l1Query.where)
      //console.log(l2Query.where)
   } else {
     return;
   }

    let arrDataAll = []

    let arrL1osm = []

    let osmLayer = featureService.operator
    // support for all types
    let featuresOSM = await queryFeaturesOverLimit2k(osmLayer, l1osmQuery, mapContext)
        //console.log(features)
        featuresOSM.forEach(element => {
            delete element.attributes.created_at
            delete element.attributes.updated_at
            arrL1osm.push(element.attributes)
        });
        
        
    
    for ( let i = 0; i < mapContext.state.compareLayers.length; i++) {
        let features = await queryFeaturesOverLimit2k(mapContext.state.compareLayers[i], l1Query, mapContext)
            if (features.length === 0) {
              return
            }
            arrDataAll.push([])
            features.forEach(element => {
            
                arrDataAll[i].push(addTransportType(element.layer.layerId, element.attributes))
            });
        mergeArr( arrDataAll[i], arrL1osm)
        // Pabaigt perdaryt supporta visiems tipams
    }
    setExcelData(arrDataAll)
  }

// paquerinami osm tinklo layeris ir operatoriu tinklai laiko palyginime, ir sudedami i viena array'u exportavimui
  function formatDataTime()
  {
    
    let l1Query
    let l2Query
    let l1osmQuery
    let l2osmQuery
    //console.log(mapContext.state.selectedStreetArray[0])
    if (mapContext.state.selectedStreetArray.length > 1) {
      l1Query = createQuery(mapContext.state.selectedStreetArray[1])
      l2Query = createQuery(mapContext.state.selectedStreetArray[1], 1)
      l1osmQuery = createQuery(mapContext.state.selectedStreetArray[1], 0, 1)
      l2osmQuery = l1osmQuery
      //console.log(l1Query.where)
      //console.log(l2Query.where)
   } else {
     return;
   }

    let arrL1data = []
    let arrL2data = []
    let arrL1osm = []
    let arrL2osm = []
    let arrL1 = []
    let arrL2 = []
    let osmLayer = featureService.operator
    queryFeaturesOverLimit2k(mapContext.state.dataFeatureLayer, l1Query, mapContext).then((features) => {
        //console.log(features)
        features.forEach(element => {
            arrL1data.push(element.attributes)
        });
        queryFeaturesOverLimit2k(mapContext.state.dataFeatureLayer, l2Query, mapContext).then((features) => {
            //console.log(features)
            features.forEach(element => {
                arrL2data.push(element.attributes)
            });
            queryFeaturesOverLimit2k(osmLayer, l1osmQuery, mapContext).then((features) => {
                features.forEach(element => {
                    delete element.attributes.created_at
                    delete element.attributes.updated_at
                    arrL1osm.push(element.attributes)
                });
                mergeArr(arrL1data, arrL1osm)
                queryFeaturesOverLimit2k(osmLayer, l2osmQuery, mapContext).then((features) => {
                    features.forEach(element => {
                        delete element.attributes.created_at
                        delete element.attributes.updated_at
                        arrL2osm.push(element.attributes)
                    });
                    mergeArr(arrL2data, arrL2osm)
                    
                    arrL1 = arrL1data
                    arrL2 = arrL2data
                    setExcelData([arrL1, arrL2])
                })
            })
        })
    })
  }

  // paquerinami osm tinklo layeris ir operatoriu tinklai atkarpos palyginime, ir sudedami i viena array'u exportavimui

  async function formatDataStr()
  {
    let a1Query
    let a2Query
    let a1osmQuery
    let a2osmQuery
    if (mapContext.state.selectedStreetArray.length > 1) {
       a1Query = createQuery(mapContext.state.selectedStreetArray[0])
       a2Query = createQuery(mapContext.state.selectedStreetArray[1])
       a1osmQuery = createQuery(mapContext.state.selectedStreetArray[0], 0, 1)
       a2osmQuery = createQuery(mapContext.state.selectedStreetArray[1], 0, 1)
       //console.log(a1Query)
       //console.log(a2Query)
    } else {
      return;
    }

    let arrA1data = []
    let arrA2data = []
    let arrA1osm = []
    let arrA2osm = []
    let arrA1 = []
    let arrA2 = []
    let osmLayer = featureService.operator
    queryFeaturesOverLimit2k(mapContext.state.dataFeatureLayer, a1Query, mapContext).then((features) => {
        //console.log(features)
        features.forEach(element => {
            arrA1data.push(element.attributes)
        });
        queryFeaturesOverLimit2k(mapContext.state.dataFeatureLayer, a2Query, mapContext).then((features) => {
            //console.log(features)
            features.forEach(element => {
                arrA2data.push(element.attributes)
            });
            queryFeaturesOverLimit2k(osmLayer, a1osmQuery, mapContext).then((features) => {
                features.forEach(element => {
                    delete element.attributes.created_at
                    delete element.attributes.updated_at
                    arrA1osm.push(element.attributes)
                });
                mergeArr(arrA1data, arrA1osm)
                queryFeaturesOverLimit2k(osmLayer, a2osmQuery, mapContext).then((features) => {
                    features.forEach(element => {
                        delete element.attributes.updated_at
                        delete element.attributes.created_at
                        arrA2osm.push(element.attributes)
                    });
                    mergeArr(arrA2data, arrA2osm)
                    
                    arrA1 = arrA1data
                    arrA2 = arrA2data
                    setExcelData([arrA1, arrA2])
                })
            })
        })
    })
}

// nukreipiama i funkcija kuri formuoja duomenis priklausomai nuo uzduoties
function download() {
    
    // Prepare data for excel.You can also use html tag for create table for excel.
    if (mapContext.state.compareTask === 3) {
        formatDataTer()
    } else if (mapContext.state.compareTask === 2) {
        formatDataTime()
    } else  {
        formatDataStr().then((queriedData) => {
            //console.log(queriedData)
        })
    }

    
  }

  // funkcija apskaicuoti datai i failo pavadinima
  function calculateDate(dateStr) {
    //console.log(dateStr)
    if (parseInt(dateStr.substring(2,4)) < 30) {
        if (parseInt(dateStr.substring(2,4)) !== 28) {
            return dateStr
        } else if (parseInt(dateStr.substring(2,4)) === 28 && parseInt(dateStr.substring(0,2)) === 2 ) {
            return "0301" + dateStr.substring(4,8)
        }
    } else {
        if (parseInt(dateStr.substring(2,4)) === 30) {
            let parsedMonth = parseInt(dateStr.substring(0,2))
            if ([4,6,9,11].includes(parsedMonth)) {
                parsedMonth++
                if (parsedMonth  < 10) {
                    return "0" + parsedMonth  + "01" + dateStr.substring(4,8)
                } else {
                    return parsedMonth  + "01" + dateStr.substring(4,8)
                }
            }
        } else if (parseInt(dateStr.substring(2,4)) === 31) {
            let parsedMonth = parseInt(dateStr.substring(0,2))
            //console.log(parsedMonth)
            if ([1,3,5,7,8,10].includes(parsedMonth)) {
                if ((parsedMonth + 1) < 10) {
                    return "0" + (parsedMonth + 1) + "01" + dateStr.substring(4,8)
                } else {
                    return (parsedMonth + 1) + "01" + dateStr.substring(4,8)
                }
            } else if ((parsedMonth + 1) === 13) {
                return "01" + "01" + (parseInt(dateStr.substring(4,8)) + 1)
            }
        }
    }
  }

  
  useEffect(() => {
    if (excelData === null) {
        return
    }
    // Headeriai excelio failui
    let data
    if (mapContext.state.compareTask === 3) {
        data = [
            [ 'Atkarpos unikalus ID', 'Gatvės pavadinimas', 'Tipas', 'Srauto dydis', 'Transporto tipas' , 'Duomenų užkelimo data', 'Duomenų atnaujinimo data', 'Srauto fiksavimo data ir laikas' ] // This is your header.
            
        ];
    } else {
        data = [
            [ 'Atkarpos unikalus ID', 'Gatvės pavadinimas', 'Tipas', 'Srauto dydis', 'Duomenų užkelimo data', 'Duomenų atnaujinimo data', 'Srauto fiksavimo data ir laikas' ] // This is your header.
            
        ];
    }
    let excelDataFoo = '';

    // sudedami like duomenys i excelio faila
    if (mapContext.state.compareTask === 3) {
        for (let i = 0; i < mapContext.state.compareLayers.length ; i ++) {
            excelData[i].forEach((element) => {
                let date =  new Date(element.datetime)
                data.push([element.OBJECTID, element.name, element.highway, element.usage, element.transport_type, new Date(element.created_at), new Date(element.updated_at), date.toString()])
            })
        }
    } else 

    {
        excelData[0].forEach((element) => {
        //console.log(element)

            let date =  new Date(element.datetime)
            data.push([element.OBJECTID, element.name, element.highway, element.usage, new Date(element.created_at), new Date(element.updated_at), date.toString()])

       
        })
        excelData[1].forEach((element) => {

            let date =  new Date(element.datetime)
            data.push([element.OBJECTID, element.name, element.highway, element.usage, new Date(element.created_at), new Date(element.updated_at), date.toString()])

        })
    }

    data.forEach(( rowItem, rowIndex ) => {   
        
        if (0 === rowIndex) {
            // This is for header.
        rowItem.forEach((colItem, colIndex) => {
            excelDataFoo += colItem + ',';
        });
        excelDataFoo += "\r\n";
        } else {
            // This is data.
            rowItem.forEach((colItem, colIndex) => {
                excelDataFoo += colItem + ',';   
        })
        excelDataFoo += "\r\n";       
        }
    });

    excelDataFoo = "data:text/xlsx," + encodeURI(excelDataFoo);
    // Download the xlsx file.
    let a = document.createElement("A");
    a.setAttribute("href", excelDataFoo);
    a.setAttribute("download", "filename.csv");
    document.body.appendChild(a);

    var ws = utils.aoa_to_sheet(data)
    var wb = utils.book_new();
    
    utils.book_append_sheet(wb, ws, "Palyginimas");
    let transport = ""
    if (mapContext.state.compareTask === 3) {
        for ( let i = 0; i < mapContext.state.compareLayers.length; i++) {
            if (mapContext.state.compareLayers[i].layerId === 101) {
                transport += "_AUTO"
              }
              if (mapContext.state.compareLayers[i].layerId === 102) {
                transport += "_DV"
              }
              if (mapContext.state.compareLayers[i].layerId === 104) {
                transport += "_VT"
              }
              if (mapContext.state.compareLayers[i].layerId === 103) {
                transport += "_PST"
              }
        }
    }
    else if (mapContext.state.transportation === "Car") {
        transport = "_AUTO"
    } else if (mapContext.state.transportation === "Bike") {
        transport = "_DV"
    } else if (mapContext.state.transportation === "Pedestrian") {
        transport = "_PST"
    } else if (mapContext.state.transportation === "Bus") {
        transport = "_VT"
    }
    //"datetime >= timestamp'09/04/2023 23:59:59' and datetime < timestamp'09/09/2023 23:59:59'"
    let dateStartIncorrect = mapContext.state.dateRange.substring(22, 26).replaceAll('/', '') +  (mapContext.state.dateRange.substring(26, 27)) + mapContext.state.dateRange.substring(27, 32).replaceAll('/', '')
    let dateStart = calculateDate(dateStartIncorrect)
    let date = dateStart + "_" + mapContext.state.dateRange.substring(68, 78).replaceAll('/', '')
    let nameStr = "export_" + date + transport + ".csv"
    writeFile(wb, nameStr);
  }, [excelData])
  return (
    <button className="NonActive LengthBtn MarginBtn" id="exportBtn" onClick={() => {download()}}>Atsisiųsti</button>
  )
}
